import React from "react";
import Select from "react-select";
import { useLocation } from "react-router-dom";
import { gettext } from "../../adapter";

const SensorDropdown = ({ sensor }) => {
  const location = useLocation();
  var sensorscache = JSON.parse(window.localStorage.getItem("sensorsDDCache"));

  if (sensorscache && sensorscache.length > 1) {
    sensorscache.sort(function (a, b) {
      if (!a || !a.name) {
        return -1;
      } else if (!b || !b.name) {
        return 1;
      }
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });
    var defaultOption;
    var sensorOptions = sensorscache.map(function (s) {
      if (sensor.id === s.id) {
        defaultOption = { value: s.id, label: s.name };
      }
      return { value: s.id, label: s.name };
    });

    return (
      <div className="tabs">
        <div className="l-left">
          <Select
            defaultValue={defaultOption}
            options={sensorOptions}
            className="react-select-container"
            classNamePrefix="react-select"
            noOptionsMessage={(input) => gettext("No results for") + ' "' + input.inputValue + '"'}
            onChange={(selected) => {
              window.location.href =
                location.pathname.replace(sensor.id, selected.value) + location.search;
            }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="l-one-third">
        <h2>{sensor.name}</h2>
      </div>
    );
  }
};

export default SensorDropdown;
